import { render, staticRenderFns } from "./Datepicker-component.vue?vue&type=template&id=5cdcdf0b"
import script from "./Datepicker-component.vue?vue&type=script&lang=js"
export * from "./Datepicker-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports